import React, { useEffect, useMemo } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { actions as ConnectionActions } from "../../Ducks/Connection.duck";
import Typography from "@mui/material/Typography";
import { Skeleton } from "@mui/material";
import { NotFoundView } from "../../../../views";
import TabOutlet from "app/components/TabOutlet";
import { HasAccessTo } from "app/components/Authorization";
import { BATCH, CONNECTION, EVENT } from "../../../../common/Authorization/entities";
import { DOWNLOAD, VIEW } from "../../../../common/Authorization/permissions";
import { isNil } from "app/utils";
import { TranslationKeys } from "../../../../translations";
import { useEmployerDetailContext } from "../../../Employers/Pages/EmployerDetailPage/EmployerDetailContext";
import { ConnectionSourcePackageTypeEnum } from "../../../../types";
const ConnectionDetailsPage = () => {
  const dispatch = useDispatch();
  const { connectionId } = useParams();
  const { item: connection, loaded, loading } = useSelector((state) => state.ConnectionReducer);
  const { employerDetail: employer } = useEmployerDetailContext();
  useEffect(() => {
    if (!isNil(connectionId) && (!connection || connection.connectionId !== connectionId)) {
      dispatch(ConnectionActions.requestData(connectionId));
    }
  }, [connection, dispatch, connectionId]);
  const disabledIfNoAccessToConnectionDownload = !HasAccessTo(CONNECTION, DOWNLOAD);
  const disabledIfNoAccessToEventView = !HasAccessTo(EVENT, VIEW);
  const disabledIfNoAccessToBatchView = !HasAccessTo(BATCH, VIEW);
  const tabData = useMemo(() => {
    return [
      {
        path: "info",
        label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.tab.general" })
      },
      {
        path: "events",
        label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.tab.events" }),
        disabled: disabledIfNoAccessToEventView
      },
      {
        path: "batches",
        label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.tab.batches" }),
        disabled: disabledIfNoAccessToBatchView
      },
      {
        path: "downloads",
        label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.tab.downloads" }),
        disabled: disabledIfNoAccessToConnectionDownload
      },
      {
        path: "files",
        label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.tab.files" }),
        disabled: !connection?.packages?.some((p) => p.packageType === ConnectionSourcePackageTypeEnum.OCR)
      },
      ...employer?.isPensioenbijIntegration ? [
        {
          path: "pensioenbij",
          label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: TranslationKeys.global_pensioenbij })
        }
      ] : []
    ];
  }, [
    disabledIfNoAccessToBatchView,
    disabledIfNoAccessToConnectionDownload,
    disabledIfNoAccessToEventView,
    connection?.packages,
    employer?.isPensioenbijIntegration
  ]);
  const title = useMemo(() => {
    if (connection?.connectionName) {
      return /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, connection.connectionName);
    }
    return /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, /* @__PURE__ */ React.createElement(Skeleton, { variant: "text", width: 200 }));
  }, [connection]);
  const breadcrumb = useMemo(() => {
    return {
      title: connection?.connectionName,
      data: {
        titleElement: title
      }
    };
  }, [connection, title]);
  const exists = loading || loaded && !!connection;
  return exists ? /* @__PURE__ */ React.createElement(TabOutlet, { tabs: tabData, breadcrumb }) : /* @__PURE__ */ React.createElement(Routes, null, /* @__PURE__ */ React.createElement(Route, { element: /* @__PURE__ */ React.createElement(NotFoundView, null), path: "*" }));
};
export default ConnectionDetailsPage;
